import { render, staticRenderFns } from "./sub-menu-item.vue?vue&type=template&id=b3664f78&"
import script from "./sub-menu-item.vue?vue&type=script&lang=js&"
export * from "./sub-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports